import angular from "angular";
import train from "../train";
import core from "../../core/core.module";

angular
    .module('trainsControl.trainForm', [train, core])
    .component('trainForm', {
        template: require('./train-form.html'),
        controller: ['Train', 'notifier', controller],
        bindings: {
            resolve: '<',
            dismiss: '&',
            close: '&'
        }
    });

function controller(Train, notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.number = null;
        $ctrl.start_station = null;
        $ctrl.end_station = null;
        $ctrl.type = null;

        if ($ctrl.resolve.train) {
            $ctrl.number = $ctrl.resolve.train.number;
            $ctrl.start_station = $ctrl.resolve.train.start_station;
            $ctrl.end_station = $ctrl.resolve.train.end_station;
            $ctrl.type = $ctrl.resolve.train.type;
        }
    };

    $ctrl.submit = function () {

        let params = {
            number: $ctrl.number,
            type: $ctrl.type
        };

        let defer = $ctrl.number ? Train.update($ctrl.number, params) : Train.store(params);

        $ctrl.loading = true;

        defer.then(
            function () {
                $ctrl.loading = false;
                $ctrl.close({
                    $value: {
                        type: $ctrl.type
                    }
                });
            },
            function (error) {
                $ctrl.loading = false;
                notifier.errorResponseNotify(error);
            }
        );

    };
}

export default 'trainsControl.trainForm';


// WEBPACK FOOTER //
// ./resources/assets/modules/trains-control/train-form/train-form.js